module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1528-b19302b085f12429e82ea499f89f105f.png";